// Pure gating logic for editing a saved draft quote in OrderConfirmation.
// Kept side-effect free so it can be unit tested in isolation.
//
//   quoteEditUnlocked - user is actively editing a saved draft quote
//   gridReadOnly       - material/labor grid inputs + actions are locked
//   allowLocalMerge    - localStorage-selected items may be merged into the grid
export function deriveQuoteEditFlags({ isDraftQuote, isEditingQuote, checkOrder, isQuality }) {
  const quoteEditUnlocked = Boolean(isDraftQuote && isEditingQuote);
  const gridReadOnly = Boolean(checkOrder && !quoteEditUnlocked);
  const allowLocalMerge = Boolean(isQuality || !checkOrder || quoteEditUnlocked);
  return { quoteEditUnlocked, gridReadOnly, allowLocalMerge };
}

// Decide how a line-item delete should be applied in OrderConfirmation:
//   'local' - drop it from the grid + local selection (unsaved / editable items)
//   'api'   - call the backend delete for a persisted order line item
//   'none'  - not permitted (e.g. viewing a locked/read-only quote)
//
// hasValidOrderKey is true only when the item carries a backend id
// (orderMaterialId/orderProductId/orderLaborId > 0). A newly-added item has none,
// so during quote edit / quality / creation (allowLocalMerge) it must be removed
// locally — the delete gate must use allowLocalMerge (which includes the
// quoteEditUnlocked term) rather than a hand-rolled (isQuality || !checkOrder).
export function resolveDeleteAction({ hasValidOrderKey, allowLocalMerge, isQuality }) {
  if (!hasValidOrderKey && allowLocalMerge) return 'local';
  if (hasValidOrderKey && !isQuality) return 'api';
  if (allowLocalMerge) return 'local';
  return 'none';
}
